import FileDownload from 'js-file-download';
import { fetchGrades } from '../../../core/assignments/api';
import { accessToken as getAccessToken } from '../../../core/selectors/user';
import jsToCsv from '../../utils/jsToCsv';

import { analyticsTrackEvent } from '../../../core/utils/analytics';
import * as analyticEvents from '../../../core/constants/analytics';

const gradesFields = ['firstName', 'lastName', 'email', 'grade', 'externalId'];

const exportSubmissionGrades = ({
  assignment: { objectId: assignmentId, title },
  spaceId,
}) => async (_, getState) => {
  const state = getState();
  const { data } = await fetchGrades({
    assignmentId,
    spaceId,
    accessToken: getAccessToken(state, spaceId),
  });

  analyticsTrackEvent(analyticEvents.EXPORT_ASSIGNMENT_GRADES, {
    assignment: { objectId: assignmentId, title },
    activeClassroom: spaceId,
  });

  FileDownload(
    jsToCsv(gradesFields, data.grades),
    `${title}.csv`,
    'text/csv;charset=utf-8;'
  );
};

export default exportSubmissionGrades;
